import { Routes, Route } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import AdminDashboard from "./AdminDashboard";
import AdminApprovals from "./AdminApprovals";
import AdminCredores from "./AdminCredores";
import AdminPendingActions from "./AdminPendingActions";
import AdminUsers from "./AdminUsers";
import AdminMonitoring from "./AdminMonitoring";
import AdminReconciliation from "./AdminReconciliation";
import AdminKycPending from "./AdminKycPending";

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-background" data-testid="admin-layout">
      <Sidebar type="admin" />
      <div className="lg:ml-64 min-h-screen">
        <Routes>
          <Route index element={<AdminDashboard key="overview" />} />
          <Route path="dashboard" element={<AdminDashboard key="overview" />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="companies" element={<AdminDashboard key="companies" tab="companies" />} />
          <Route path="approvals" element={<AdminApprovals />} />
          <Route path="pending-actions" element={<AdminPendingActions />} />
          <Route path="kyc" element={<AdminKycPending />} />
          <Route path="credores" element={<AdminCredores />} />
          <Route path="anticipations" element={<AdminDashboard key="anticipations" tab="anticipations" />} />
          <Route path="audit" element={<AdminDashboard key="audit" tab="audit" />} />
          <Route path="monitoring" element={<AdminMonitoring />} />
          <Route path="reconciliation" element={<AdminReconciliation />} />
        </Routes>
      </div>
    </div>
  );
}
